import { render, staticRenderFns } from "./EditOrderModal.vue?vue&type=template&id=2b2f357c&scoped=true"
import script from "./EditOrderModal.vue?vue&type=script&lang=js"
export * from "./EditOrderModal.vue?vue&type=script&lang=js"
import style0 from "./EditOrderModal.vue?vue&type=style&index=0&id=2b2f357c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b2f357c",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/pages/Purchases/PurchaseOrderTracking/EditOrderModal.vue
// module id = 2346
// module chunks = 31